/* @flow */

import * as React from 'react';
import {Helmet} from 'react-helmet';

import {headTitle} from '../document';
import {MainContentContainer} from '.';

type Props = {
    title: string,
    children: React.Node,
};

export function EmailMarketingPageContainer(props: Props) {
    return (
        <>
            <Helmet>
                <title>{headTitle(props.title)}</title>
            </Helmet>
            <MainContentContainer whiteBackground={true}>{props.children}</MainContentContainer>
        </>
    );
}
